import axios from "axios";
import Swal from "sweetalert2";
import { tokenConfig } from "./websiteActions";
import { t } from "i18next";

const getListPrinters = (page = 0, sizeperpage = 0, search = "") => (dispatch, getState) => {
	dispatch({type: 'LOADING_PRINTER', payload: true});
	var param_search = "";
	if (search !== "") {
		param_search = `&search=${search}`;
	}
	axios.get(`/api/printer/list?page=${page}&sizeperpage=${sizeperpage}${param_search}`, tokenConfig(getState)).then(res => {
		dispatch({type: 'LOADING_PRINTER', payload: false});
		if (res.data.status === 200) {
			dispatch({
				type: 'LIST_PRINTER',
				payload: res.data.data
			});
		} else {
			Swal.fire(t("Error"), t(res.data.message), 'error');
		}
	}).catch(err => {
		dispatch({type: 'LOADING_PRINTER', payload: false});
		Swal.fire(t("Error"), t("An error occurred!"), 'error');
	});
};

const saveAddPrinter = (data, closemodal) => (dispatch, getState) => {
	var body = {
		printer: data.printer,
		username: data.username,
		password: data.password,
		access_token: data.access_token,
		auto_place: data.auto_place,
		api_key: data.api_key,
		api_signature: data.api_signature,
		api_secret: data.api_secret,
		api_store_id: data.api_store_id,
		api_store_id_spoke_custom_products: data.api_store_id_spoke_custom_products,
		api_store_id_swiftpod: data.api_store_id_swiftpod,
		api_store_id_monster_digital: data.api_store_id_monster_digital,
		api_store_id_printed_mint: data.api_store_id_printed_mint,
		api_store_id_lumient: data.api_store_id_lumient,
		api_store_id_swagrabbit: data.api_store_id_swagrabbit,
		api_store_id_candle_builders: data.api_store_id_candle_builders,
		api_store_id_prima_printing: data.api_store_id_prima_printing,
		api_store_id_district_photo: data.api_store_id_district_photo,
		api_store_id_todays_graphics: data.api_store_id_todays_graphics,
		api_store_id_harrier: data.api_store_id_harrier,
		api_store_id_print_pigeons: data.api_store_id_print_pigeons,
		api_store_id_colorway: data.api_store_id_colorway,
		api_store_id_printed_simply: data.api_store_id_printed_simply,
		api_store_id_imagine_your_photos: data.api_store_id_imagine_your_photos,
		api_store_id_pic_the_gift: data.api_store_id_pic_the_gift,
		api_store_id_woyc: data.api_store_id_woyc,
		api_store_id_smart_printee: data.api_store_id_smart_printee,
		api_store_id_shirt_monkey: data.api_store_id_shirt_monkey,
		api_store_id_t_shirt_and_sons: data.api_store_id_t_shirt_and_sons,
		api_store_id_print_clever: data.api_store_id_print_clever,
		api_store_id_printify_choice: data.api_store_id_printify_choice,
		api_store_id_printful_com: data.api_store_id_printful_com,
		api_store_id_opt_ondemand: data.api_store_id_opt_ondemand,
		api_store_id_atelier_katanga: data.api_store_id_atelier_katanga,
		webhook_secret_key: data.webhook_secret_key,
		base_url: data.base_url,
		client_id: data.client_id,
		client_secret: data.client_secret,
		data: data.data,
		app_key: data.app_key,
		app_secret: data.app_secret,
	};
	Swal.fire({
		title: t("Are you sure?"),
		text: t("Are you sure to add printer?"),
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: t("Sure"),
		cancelButtonText: t("Cancel")
	}).then((result) => {
		if (result.value) {
			dispatch({type: 'LOADING_PRINTER', payload: true});
			axios.post('/api/printer/add', body, tokenConfig(getState)).then(res => {
				dispatch({type: 'LOADING_PRINTER', payload: false});
				if (res.data.status === 200) {
					closemodal();
					dispatch(getListPrinters(1, 9999));
					Swal.fire(t("Success"), t(res.data.message), 'success');
				} else {
                    Swal.fire(t("Error"), t(res.data.message), 'error');
				}
			}).catch(err => {
				dispatch({type: 'LOADING_PRINTER', payload: false});
                Swal.fire(t("Error"), t("An error occurred!"), 'error');
			});
		}
	})
};

const deletePrinter = (data) => (dispatch, getState) => {
	var body = {
		_id: data._id
	};
	Swal.fire({
		title: t("Are you sure?"),
		text: t("Are you sure to delete printer?"),
		icon: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#3085d6',
		cancelButtonColor: '#d33',
		confirmButtonText: t("Sure"),
		cancelButtonText: t("Cancel")
	}).then((result) => {
		if (result.value) {
			dispatch({type: 'LOADING_PRINTER', payload: true});
			axios.post('/api/printer/delete', body, tokenConfig(getState)).then(res => {
				dispatch({type: 'LOADING_PRINTER', payload: false});
				if (res.data.status === 200) {
					dispatch(getListPrinters(1, 9999));
					Swal.fire(t("Success"), t(res.data.message), 'success');
				} else {
					Swal.fire(t("Error"), t(res.data.message), 'error');
				}
			}).catch(err => {
				dispatch({type: 'LOADING_PRINTER', payload: false});
                Swal.fire(t("Error"), t("An error occurred!"), 'error');
			});
		}
	})
};

const getWalletbalancePrinter = (printer) => (dispatch, getState) => {
	return axios.get(`/api/printer/wallet-balance?printer=${printer}`, tokenConfig(getState)).then(res => {
		if (res.data.status === 200) {
			return res.data.data;
		} else {
			return { balance: 0, currency: "USD" };
		}
	}).catch(err => {
		return { balance: 0, currency: "USD" };
	});
};

export {
    getListPrinters,
    saveAddPrinter,
    deletePrinter,
    getWalletbalancePrinter,
};
